import _implicitStylesheets from "./linkRenderer.css";
import _implicitScopedStylesheets from "./linkRenderer.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment2 = parseFragment`<a${"a0:href"}${"a0:target"}${3}>${"t1"}</a>`;
const stc0 = {
  classMap: {
    "link-renderer__paragraph": true
  },
  attrs: {
    "type-style": "body-2"
  },
  key: 0
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, i: api_iterator, h: api_element} = $api;
  return [api_element("p", stc0, api_iterator($cmp.renderedElements, function (element) {
    return [!element.link ? api_static_fragment($fragment1, api_key(2, element.text), [api_static_part(1, null, api_dynamic_text(element.text))]) : null, element.link ? api_static_fragment($fragment2, api_key(4, element.text), [api_static_part(0, {
      attrs: {
        "href": element.link,
        "target": $cmp.linkTarget
      }
    }, null), api_static_part(1, null, api_dynamic_text(element.text))]) : null];
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-456mi9hocv1";
tmpl.legacyStylesheetToken = "undefined-_linkRenderer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
